import React from 'react'
import classNames from 'classnames'
import { useAngelPlayerContext } from '@/organisms/AngelPlayer'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { getProjectTheme } from '@/utils/project-themes'

interface PlayerLogoOverlayProps {
  logoCloudinaryPath: string
  name: string
  slug: string
}

export const PlayerLogoOverlay: React.FC<PlayerLogoOverlayProps> = ({ logoCloudinaryPath, name, slug }) => {
  const { playing } = useAngelPlayerContext()
  const { payItForward } = getProjectTheme(slug)

  return (
    <div
      className={classNames(
        'absolute top-4 right-4 duration-300 transition-opacity',
        payItForward?.logoOverlayClassName ?? 'w-1/3',
        {
          'opacity-0': playing,
        },
      )}
    >
      <img alt={name} src={getCloudinaryImageUrl({ path: logoCloudinaryPath })} />
    </div>
  )
}
